import { defineMessages } from '@alltrails/shared/react-intl';

const OUR_CULTURE_STRINGS = defineMessages({
  TEN_K_REASONS: {
    defaultMessage: '10k reasons to get outside'
  },
  THREE_HUNDRED_K: {
    defaultMessage: '350k+'
  },
  CURATED_TRAILS: {
    defaultMessage: 'curated trails'
  },
  THIRTY_FIVE_MIL: {
    defaultMessage: '40 mil'
  },
  FELLOW_EXPLORERS: {
    defaultMessage: 'fellow explorers'
  },
  ONE: {
    defaultMessage: '1'
  },
  GLOBAL_COMMUNITY: {
    defaultMessage: 'global community'
  }
});

export default OUR_CULTURE_STRINGS;
